import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  LoginPostParams,
  loginService,
  verifyByEmail,
  verifyCodeService,
} from '../services/login.service';

export const loginUser = createAsyncThunk(
  'auth/login',
  async (params: LoginPostParams, { rejectWithValue }) => {
    try {
      return await loginService(params);
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const verifyCode = createAsyncThunk(
  'auth/login/verify-code',
  async (code: string, { rejectWithValue }) => {
    try {
      return await verifyCodeService(code);
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);

export const sendCodeByEmail = createAsyncThunk(
  'auth/login/email',
  async (token: string, { rejectWithValue }) => {
    try {
      return await verifyByEmail(token);
    } catch (error: any) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  },
);
